import { render, staticRenderFns } from "./ValidationPopup.vue?vue&type=template&id=1f505a50"
import script from "./ValidationPopup.vue?vue&type=script&lang=js"
export * from "./ValidationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports